<template>
  <div class="flex items-center space-x-3.5">
    <div class="flex-shrink-0">
      <div
        class="w-9 h-9 bg-white/20 backdrop-blur-sm rounded-xl flex items-center justify-center border border-white/25 shadow-inner"
      >
        <svg
          class="w-5 h-5 text-white"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2.5"
            d="M5 13l4 4L19 7"
          ></path>
        </svg>
      </div>
    </div>
    <div class="flex-1 min-w-0">
      <p class="text-xs sm:text-sm font-bold text-white tracking-tight truncate">
        Attendance recorded successfully
      </p>
      <p class="text-[11px] text-emerald-100 flex items-center gap-1 font-medium mt-0.5">
        <span>{{ formatTodaysDate() }}</span>
        <span>•</span>
        <span>{{ getDayName() }}</span>
      </p>
    </div>
  </div>
</template>

<script setup>
  const formatTodaysDate = () => {
    const today = new Date();
    return today.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  };

  const getDayName = () => {
    const today = new Date();
    return today.toLocaleDateString("en-US", { weekday: "short" });
  };
</script>
